<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <Card :title="'Tambah Invoice (Surat Faktur)'">
          <template v-slot:body>
            <Form
              :form="form"
              :route="'purchase-orders'"
              :opening_sentence="opening_sentence"
            />
          </template>
        </Card>
      </div>
    </div>
  </div>
</template>

<script>
import Card from "@/view/content/Card.vue";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import Form from "@/component/purchase-orders/Form.vue";

export default {
  name: "Add",

  components: {
    Card,
    Form,
  },

  data() {
    return {
      // Form
      form: {
        date: new Date().toISOString().substr(0, 10),
        due_date: new Date().toISOString().substr(0, 10),
        po_no: "",
        vendor_id: "",
        vendor_name: "",
        items: "",
        discount: 0,
        ppn: "",
        // opening_sentence: `Dengan hormat, <br> Sehubungan dengan permintaan bahan habis pakai di HayandraLab pada tanggal ${this.form.date}, maka kami ingin menyampaikan sebagai berikut :`,
        closing_sentence:
          "Demikian invoice ini kami sampaikan. Untuk pelunasan maksimum 14 hari setelah pengambilan barang. Atas perhatian dan kerjasamanya kami ucapkan terima kasih.",
        items_display: [],
      },
    };
  },

  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Invoice (Surat Faktur)", route: "/purchase-orders" },
      { title: "Tambah" },
    ]);

    console.log("ini", this.opening_sentence);
  },
  computed: {
    formattedDate() {
      return new Date(this.form.date).toLocaleDateString("id-ID", {
        day: "numeric",
        month: "long",
        year: "numeric",
      });
    },
    opening_sentence() {
      return `Dengan hormat, <br> Sehubungan dengan permintaan bahan habis pakai di HayandraLab pada tanggal ${this.formattedDate}, maka kami ingin menyampaikan sebagai berikut :`;
    },
  },
};
</script>

<style>
</style>